export const generalS = {
  home: ["ده‌ستپێک", "البداية", "Home"],
  news: ["هەواڵەكان", "أخبار", "News"],
  latestProject: ["ئیڤێنتەکان و هەواڵەکان", "أحداث و أخبار", " Events and News"],
  upcomingEvents: ["ئیڤێنتەکان", "لحدث القادم", "Upcoming Events"],
  workshopTraiing: ["ۆرکشۆپەکان و ڕاهێنانەکان", "ورش العمل والدورات التدريبية", "WorkShops & Trainings"],
  calender: ["ساڵنامە", "التقويم", "Calender"],
  cultureArt: ["ناوەندی كەلتووروهونەر", "مركز الثقافة والفنون", "Culture & Art center"],
  ourMission: ["ئامانجەکانمان", "مهمتنا", "Our Mission"],
  creativeSpace: ["فەزای داهێنەرانە", "الفضاء الابداعي", "Creative Space"],
  film: [" وێستگه‌ی کاری فیلم", "الفضاء فيلم", "Film Workstation"],
  design: ["وێستگه‌ی کاری دیزاین", "الفضاء تصميم", "Design Workstation"],
  print: ["وێستگه‌ی کاری چاپکردن", "الفضاء طباعة ", "Print Workstation"],
  information: ["زانیاری", "معلومات", "Information"],
  onlineTV: ["وێستگه‌ی کاری ئۆنلاین و تەلەفیزۆن", "الفضاء تلفزيون اون لاين", "Online TV Workstation"],
  history: ["مێژوو", "التاريخ", "History"],
  about: ["دەربارەی ئێمە", "من نحن", "About Us"],
  product: ["بەرهەمەکان", "المنتج", "Products"],
  ourTeam: ["گروپەکەمان", "فريقنا", "Our Team"],
  postNotFound: ["هیچ پۆستێک بونی نیە", "لا توجد مشاركات", "No Posts"],

  cpanel: ["بۆردی بەڕێوەبردن", "لوحة التحكم", "Cpanel"],
  post: ["پۆست", "وظيفة", "post"],
  userManagment: ["بەڕێوەبردنی بەکارهێنەر", " إدارة المستخدم", "User Management"],
  readMore: ["زیاتر", "أكثر", "Read More"],
  team: ["ئەندامی تیم", "أعضاء الفريق", "Team Member"],
  homeAlbum: ["ئەلبومی پاڕەی پاڵەوە", "ألبوم الصفحة الرئيسية", "Home page album"],
  latestNewsAndEvents: ["کۆتا هەواڵ و ڕوداوەکان", "آخر الأخبار والأحداث", "Latest News & Events"],
  cooperation: ["هەرەوەزیکردن", "تعاون", "Cooperation"],
  partners: ["هاوبەش", "شركاء", "Partners"],
  logout: ["دەرچون", "تسجيل خروج", "Log Out"],
  settings: ["ڕێکخستن", "إعدادات", "Settings"],
  mobile: ["الهاتف", "مۆبایل", "Mobile"],
  email: ["البريد الإلكتروني", "ئیمەیڵ", "Email"],
  day: ["یوم", "ڕۆژ", "Day"],
  month: ["شهر", "مانگ", "Month"],
  year: ["سنة", "ساڵ", "Year"],
  search: ["گەڕان", "بحث", "Search"],
  footerText: ["نوسینی فوتەر", "نص تذييل", "Footer Text"],
  contact: ["اتصل بنا", "پەیوەندیکردن", "Contact"],
  address: ["ناونیشانەکان", "عناوين", "Addresses"],
  backToHome: ["بگەڕێرەوە بۆ ماڵەوە", "عد الى الصفحة الرئيسية", "Back to Home"],
  pageNotFound: ["لاپەڕەکە نەدۆزرایەوە", "الصفحة غير موجودة", "Page Not found"],
  homeImageDivider: ["وەێنەی جیاکەرەوە لەمالەوە", "مقسم صورة مقسم صورة", "Home Image Divider"],
};
